import { createAction, props } from '@ngrx/store';
import { BadResponseWithError } from '@shared/models/common.interface';
import {
    CryptoWalletNetworkType,
    GiftCardProviderType,
    WithdrawalRequestFilter,
    WithdrawalRequestPaymentMethodType,
    WithdrawalRequestStatusType,
} from '../../models/withdrawals.interface';
import { WithdrawalRequestsWithPagination } from '../../models/api/response/user-management.response';
import { WithdrawalRequest } from '../../models/api/requests/user-management.request';

export type Filter = { [key: string]: string | string[] };

export const FETCH_WITHDRAWAL_REQUESTS = '[Wallet] Fetch withdrawal requests';
export const FETCH_WITHDRAWAL_REQUESTS_SUCCESS =
    '[Wallet] Fetch withdrawal requests success';
export const FETCH_WITHDRAWAL_REQUESTS_FAILURE =
    '[Wallet] Fetch withdrawal requests failure';

export const CHANGE_WITHDRAWAL_REQUEST_STATUS =
    '[Wallet] Change withdrawal request status';
export const CHANGE_WITHDRAWAL_REQUEST_STATUS_SUCCESS =
    '[Wallet] Change withdrawal request status success';
export const CHANGE_WITHDRAWAL_REQUEST_STATUS_FAILURE =
    '[Wallet] Change withdrawal request status failure';

export const ADD_HASH_TO_CRYPTO_WITHDRAWAL_REQUEST =
    '[Wallet] Add hash to crypto withdrawal request';
export const ADD_HASH_TO_CRYPTO_WITHDRAWAL_REQUEST_SUCCESS =
    '[Wallet] Add hash to crypto withdrawal request success';
export const ADD_HASH_TO_CRYPTO_WITHDRAWAL_REQUEST_FAILURE =
    '[Wallet] Add hash to crypto withdrawal request failure';

export const DOWNLOAD_WITHDRAWAL = '[Wallet]: Download withdrawal';
export const DOWNLOAD_WITHDRAWAL_SUCCESS =
    '[Wallet]: Download withdrawal success';
export const DOWNLOAD_WITHDRAWAL_FAILURE =
    '[Wallet]: Download withdrawal failure';

export const fetchWithdrawalRequests = createAction(
    FETCH_WITHDRAWAL_REQUESTS,
    props<{
        payload?: {
            status?: WithdrawalRequestStatusType;
            paymentMethod?: WithdrawalRequestPaymentMethodType;
            network?: CryptoWalletNetworkType;
            giftCardProvider?: GiftCardProviderType;
        };
    }>()
);

export const fetchWithdrawalRequestsSuccess = createAction(
    FETCH_WITHDRAWAL_REQUESTS_SUCCESS,
    props<{
        payload: {
            items: WithdrawalRequestsWithPagination;
        };
    }>()
);

export const fetchWithdrawalRequestsFailure = createAction(
    FETCH_WITHDRAWAL_REQUESTS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const changeWithdrawalRequestStatus = createAction(
    CHANGE_WITHDRAWAL_REQUEST_STATUS,
    props<{
        payload: {
            profileId: string;
            requestId: string;
            status: WithdrawalRequestStatusType;
            filters: WithdrawalRequestFilter;
        };
    }>()
);

export const changeWithdrawalRequestStatusSuccess = createAction(
    CHANGE_WITHDRAWAL_REQUEST_STATUS_SUCCESS,
    props<{
        payload: {
            request: WithdrawalRequest;
        };
    }>()
);

export const changeWithdrawalRequestStatusFailure = createAction(
    CHANGE_WITHDRAWAL_REQUEST_STATUS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const addHashToWithdrawalRequests = createAction(
    ADD_HASH_TO_CRYPTO_WITHDRAWAL_REQUEST,
    props<{
        payload: {
            cryptoHashId: string;
            withdrawalId: string;
        };
    }>()
);

export const addHashToWithdrawalRequestsSuccess = createAction(
    ADD_HASH_TO_CRYPTO_WITHDRAWAL_REQUEST_SUCCESS,
    props<{
        payload: {
            withdrawalId: string;
            cryptoHashId: string;
        };
    }>()
);

export const addHashToWithdrawalRequestsFailure = createAction(
    ADD_HASH_TO_CRYPTO_WITHDRAWAL_REQUEST_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const downloadWithdrawal = createAction(
    DOWNLOAD_WITHDRAWAL,
    props<{
        payload: {
            fileName: string;
            url: string;
        };
    }>()
);

export const downloadFileSuccess = createAction(DOWNLOAD_WITHDRAWAL_SUCCESS);

export const downloadFileFailure = createAction(
    DOWNLOAD_WITHDRAWAL_FAILURE,
    props<{ payload: BadResponseWithError }>()
);
